const cleanObject = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj;

  if (Array.isArray(obj)) {
    return obj.map(cleanObject);
  }

  return Object.keys(obj).reduce((acc, key) => {
    if (key !== "_store") {
      acc[key] = cleanObject(obj[key]);
    }
    return acc;
  }, {});
};

export const hasFormChanged = (initialValues, values) => {
  const cleanedInitialValues = cleanObject(initialValues);
  const cleanedValues = cleanObject(values);

  return JSON.stringify(cleanedInitialValues) !== JSON.stringify(cleanedValues);
};
